import React from "react";
import { FormTab, Show, TabbedForm, usePermissions, useShowController } from "react-admin";
import DocumentTitle from "../common/documentTitle/DocumentTitle";
import DescriptionTabForm from "./DescriptionTabForm";
import CreateWinnerGeneralTabForm from "./GeneralTabForm";
import { checkPermission } from "../../helpers/checkPermissions";

const ViewWinner = (props) => {
  const { permissions } = usePermissions()
  const controllerProps = useShowController<any>(props);

  console.log("controllerProps.record", controllerProps.record);
  
  return (
    <>
      <DocumentTitle
        core="Winners"
        purpose={`${controllerProps.record?.name}`}
        appointment=""
      />

      <Show {...props} hasEdit={checkPermission(permissions, "Winners", "Update") ? true : false}>
        {controllerProps.record && (
          <TabbedForm toolbar={<></>}>
            <FormTab label="Description">
              <DescriptionTabForm
                record={controllerProps.record}
                disabledInputs={true}
                {...props}
              />
            </FormTab>
          </TabbedForm>
        )}
      </Show>
    </>
  );
};
export default ViewWinner;
